import { useState, useEffect } from "react";
import { useMyContext } from "../../components/Provider/CommonProvider";
import Ads_Categories_01 from "../../components/Images/sidebar_icon/Ads_Categories_01.svg";
import Ads_Plans_01 from "../../components/Images/sidebar_icon/Ads_Plans_01.svg";
import Manage_Advertiser_01 from "../../components/Images/sidebar_icon/Manage_Advertiser_01.svg";
import add_list_01 from "../../components/Images/sidebar_icon/add_list_01.svg";

const NavigationData = (labelDisplay) => {
    const { isExpired, getExpiryMessage, fetchRequest, accessToken } = useMyContext();

    const superAdminURL = [
        {
            url: '/playout-settings',
            message: `Playout Settings`
        },
        {
            url: '/product-type-settings',
            message: `Product Type`
        },
        {
            url: '/library-setting',
            message: `Library Settings`
        },
        {
            url: '/payment-gateways-settings',
            message: `Payment Gateway's List`
        },
        {
            url: '/storage_settings',
            message: `Storage Settings`
        },
    ]

    const videoURL = [
        {
            url: '/add-video',
            message: labelDisplay?.[5]?.title || 'Add Video'
        },
        {
            url: '/video-lists',
            message: labelDisplay?.[6]?.title || 'Video List'
        },
        {
            url: '/video-categories',
            message: labelDisplay?.[9]?.title || 'Video Categories'
        },
        {
            url: '/allplaylist',
            message: labelDisplay?.[10]?.title || 'Video Playlist'
        },
    ]
    const LibraryURL = [
        {
            url: '/add-library',
            message: labelDisplay?.[159]?.title || 'Add Library',

        },
        {
            url: '/library',
            message: labelDisplay?.[160]?.title || 'All Library'
        },
    ]

    const seriesURL = [
        {
            url: '/series-list',
            message: labelDisplay?.[15]?.title || 'Series List'
        },
        {
            url: '/add-series',
            message: labelDisplay?.[16]?.title || 'Add Series'
        },
        {
            url: '/series-category',
            message: labelDisplay?.[17]?.title || 'Series Category'
        },
    ]

    const liveURL = [
        {
            url: '/livestream',
            message: labelDisplay?.[23]?.title || 'All Live Streams'
        },
        {
            url: '/add-livestream',
            message: labelDisplay?.[24]?.title || 'Add Live Stream'
        },
        {
            url: '/livestream-categories',
            message: labelDisplay?.[26]?.title || 'Live Stream Categories'
        },
    ]


    const radioStationURL = [
        {
            url: '/radio-station',
            message: labelDisplay?.[177]?.title || 'All Radio Station'
        },
        {
            url: '/add-radio-station',
            message: labelDisplay?.[176]?.title || 'Add New Radio Station'
        },
        {
            url: '/radio-station-categories',
            message: 'Radio Station Categories'
        },
    ]

    const audioURL = [
        {
            url: '/audio-lists',
            message: labelDisplay?.[31]?.title || 'Audio List'
        },
        {
            url: '/add-audio',
            message: labelDisplay?.[32]?.title || 'Add Audio'
        },
        {
            url: '/audio-categories',
            message: labelDisplay?.[33]?.title || 'Audio Categories'
        },
        {
            url: '/manage-albums',
            message: labelDisplay?.[34]?.title || 'Manage Albums'
        },
        {
            url: '/audio-playlist',
            message: 'Audio Playlist'
        },

    ]

    const artistURL = [
        {
            url: '/all-artist',
            message: labelDisplay?.[39]?.title || 'All Artist'
        },
        {
            url: '/add-artist',
            message: labelDisplay?.[40]?.title || 'Add Artist'
        },
        {
            url: '/artist-type',
            message: 'Artist Type'
        }
    ]

    const deviceCropsURL = [
        { url: '/device-crop-rules', message: 'Device Crop Rules' },
        { url: '/add-device-crop-rule', message: 'Add Crop Rule' },
    ]
    const importExportURL = [
        {
            url: '/import-export',
            message: labelDisplay?.[780]?.title || 'Import/Export Data'
        }
    ]

    const imageOrientationURL = [
        {
            url: '/orientation-list',
            message: 'All Orientations'
        },
        {
            url: '/add-orientation',
            message: 'Add Orientation'
        },
        {
            url: '/device-crop-rules',
            message: 'All Crop Rules'
        },
        {
            url: '/add-device-crop-rule',
            message: 'Add Crop Rule'
        },
    ]

    const userURL = [
        {
            url: '/users',
            message: labelDisplay?.[45]?.title || 'All Users'
        },
        {
            url: '/add-users',
            message: labelDisplay?.[46]?.title || 'Add User'
        },
        {
            url: '/import-users-view',
            message: labelDisplay?.[47]?.title || 'Import Users'
        },
        {
            url: '/MultiUser-limit',
            message: labelDisplay?.[48]?.title || 'Multi User Management'
        }]

    const menuURL = [
        {
            url: '/menu',
            message: labelDisplay?.[50]?.title || 'Web Menu'
        },
        {
            url: '/footermenu',
            message: labelDisplay?.[51]?.title || 'Footer Menu'
        },
        {
            url: '/mobilemenu',
            message: labelDisplay?.[52]?.title || 'Mobile Menu'
        },
        {
            url: '/tvmenu',
            message: 'TV Menu'
        },
        {
            url: '/sidebarmenu',
            message: `Sidebar Menu`
        },
    ]
    const menuURLRegistrationMenu = [
        {
            url: '/signup-menu',
            message: labelDisplay?.[53]?.title || 'Registration Menu'
        },
    ]

    const languageURL = [
        {
            url: '/admin-languages',
            message: labelDisplay?.[57]?.title || 'Admin Languages'
        },
        {
            url: '/subtitlelanguage',
            message: labelDisplay?.[58]?.title || 'Subtitle Language'
        },

    ]

    const regionURL = [
        {
            url: '/admin-regions',
            message: 'Manage Region'
        },
    ]

    const translationURL = [
        {
            url: '/translate-languages',
            message: labelDisplay?.[59]?.title || 'Translate Languages'
        },
        {
            url: '/translate-languages-index',
            message: labelDisplay?.[60]?.title || 'Translate Languages Index'
        }
    ]

    const PartnerURL = [
        {
            url: '/all-partner',
            message: labelDisplay?.[161]?.title || 'All Partner'
        },
        {
            url: '/add-partner',
            message: labelDisplay?.[162]?.title || 'Add Partner'
        },
        {
            url: '/approve-partner',
            message: labelDisplay?.[163]?.title || 'Approve Partner'
        },
        {
            url: '/partner/assign',
            message: labelDisplay?.[164]?.title || 'Partner Assign'
        },
        {
            url: '/partner-content-overview',
            message: labelDisplay?.[193]?.title ? labelDisplay[193].title + ' Overview' : 'Pending Content Overview'
        },
        {
            url: '/partner-content',
            message: labelDisplay?.[193]?.title || 'Partner Content'
        },
    ]

    const Partner_payoutURL = [
        {
            url: '/partner-monetization-content',
            message: labelDisplay?.[184]?.title || 'Monetization Content'
        },
        {
            url: '/partner-monitazation-analytics',
            message: labelDisplay?.[185]?.title || 'Monetization Analytics'
        },
        {
            url: '/partner-monitazation-index',
            message: labelDisplay?.[186]?.title || 'Monetization Index'
        },

    ]

    const partnerSettingsURL = [
        {
            url: '/partner-settings',
            message: labelDisplay?.[189]?.title || 'Partner Settings'
        },
        {
            url: '/partner-monetization-settings',
            message: labelDisplay?.[190]?.title || 'Monetization Settings'
        },
    ]
    const PartnerPayout = [
        {
            url: '/partner/payouts',
            message: labelDisplay?.[165]?.title || 'Payouts'
        },
        {
            url: '/partner/payout/analytics',
            message: labelDisplay?.[166]?.title || 'Payout Analytics'
        },
        {
            url: '/partner/payment/history',
            message: labelDisplay?.[167]?.title || 'Payment History'
        },
        {
            url: '/payment/total_revenue',
            message: `Payout Revenue`
        },
    ]

    const PartnerAnalyticsURL = [
        {
            url: '/analytics/player',
            message: labelDisplay?.[179]?.title || 'Player Analytics'
        },
        {
            url: '/analytics/ViewsRegion',
            message: 'View By Region'
        },
        {
            url: '/partner/payouts',
            message: labelDisplay?.[165]?.title || 'Payouts'
        },
        {
            url: '/partner/payout/analytics',
            message: labelDisplay?.[166]?.title || 'Payout Monetization'
        },
        {
            url: '/partner/payment/history',
            message: labelDisplay?.[167]?.title || 'Payout History'
        }
    ]

    const RolesURL = [
        {
            url: '/role-index',
            message: labelDisplay?.[168]?.title || 'All Roles'
        },
        {
            url: '/role-create',
            message: labelDisplay?.[169]?.title || 'Create Role'
        },

    ]
    const pagesURL = [
        {
            url: '/pages',
            message: labelDisplay?.[84]?.title || 'Pages'
        },
        {
            url: '/landing-page/index',
            message: labelDisplay?.[85]?.title || 'Landing Page'
        },
    ]

    const plansURL = [
        {
            url: '/subscription-plans',
            message: labelDisplay?.[89]?.title || 'Subscription Plans'
        },
        {
            url: '/inapp-purchase',
            message: labelDisplay?.[90]?.title || 'In-App Purchase'
        },
        {
            url: '/idea-biz',
            message: `Idea Biz Purchase`
        },
        {
            url: '/google-product-ppv-manager',
            message: `Google Pay`
        },
        {
            url: '/devices',
            message: labelDisplay?.[92]?.title || 'Devices'
        },
        {
            url: '/plan-content-settings',
            message: `Manage Plan Content`
        },
    ]
    const paymentURL = [
        {
            url: '/payment_settings',
            message: labelDisplay?.[114]?.title || 'Payment Settings'
        },
    ]

    const playerUrl = [
        {
            url: 'players',
            message: labelDisplay?.[64]?.title || 'Player Settings'
        },
        {
            url: 'music-settings',
            message: labelDisplay?.[65]?.title || 'Music Settings'
        }
    ]
    const analyticsURL = [
        {
            url: '/analytics/users',
            message: labelDisplay?.[100]?.title || 'User Analytics'
        },
        {
            url: '/analytics/subscriber',
            message: labelDisplay?.[101]?.title || 'Subscriber Analytics'
        },
        {
            url: '/analytics/ppv',
            message: labelDisplay?.[102]?.title || 'PPV Analytics'
        },
        {
            url: '/analytics/player',
            message: labelDisplay?.[179]?.title || 'Player Analytics'
        },
    ]

    const settingsURL = [
        {
            url: '/age/index',
            message: labelDisplay?.[111]?.title || 'Age Management'
        },
        {
            url: '/theme_settings',
            message: labelDisplay?.[112]?.title || 'Theme Settings'
        },
        {
            url: '/email_settings',
            message: labelDisplay?.[113]?.title || 'Email Settings'
        },

        {
            url: '/system_settings',
            message: labelDisplay?.[117]?.title || 'System Settings'
        },
        {
            url: '/currency_settings',
            message: labelDisplay?.[118]?.title || 'Currency Settings'
        },
        {
            url: '/revenue_settings/index',
            message: labelDisplay?.[119]?.title || 'Revenue Settings'
        },
        {
            url: '/ThumbnailSetting',
            message: labelDisplay?.[120]?.title || 'Thumbnail Settings'
        },
        {
            url: '/compress-image-setting',
            message: labelDisplay?.[122]?.title || 'Compress Image'
        },
        {
            url: '/comment-section-setting',
            message: labelDisplay?.[124]?.title || 'Comments'
        },
        {
            url: '/dsp-settings',
            message: labelDisplay?.[127]?.title || 'DSP Settings'
        },
        {
            url: '/labels',
            message: labelDisplay?.[128]?.title || 'Labels'
        },
        {
            url: '/otp-credentials',
            message: labelDisplay?.[191]?.title || 'OTP Credentials'
        },
        {
            url: '/transcoding-jobs',
            message: labelDisplay?.[187]?.title || 'Transcoding Jobs'
        },
    ]
    const settingsURLhome = [

        {
            url: '/home-settings',
            message: labelDisplay?.[106]?.title || 'Home Settings'
        },
        {
            url: '/audio-settings',
            message: labelDisplay?.[107]?.title || 'Audio Settings'
        },
        {
            url: '/movie-settings',
            message: labelDisplay?.[108]?.title || 'Movie Settings'
        },
        {
            url: '/show-settings',
            message: labelDisplay?.[109]?.title || 'Show Settings'
        },
        {
            url: '/live-settings',
            message: "Live Settings"
        },
        {
            url: '/pop-up-setting',
            message: labelDisplay?.[123]?.title || 'Pop-up Setting'
        },


    ]
    const settingsURLApp = [
        {
            url: '/apps',
            message: labelDisplay?.[192]?.title || 'Apps'
        },
        {
            url: '/tv-settings',
            message: labelDisplay?.[126]?.title || 'TV Settings'
        },
        {
            url: '/ChooseProfileScreen',
            message: labelDisplay?.[121]?.title || 'Choose Profile Screen'
        },
        {
            url: '/mobileappscreen',
            message: labelDisplay?.[116]?.title || 'Mobile App Screen'
        },
    ]

    const faqURL = [
        {
            url: '/faq',
            message: labelDisplay?.[146]?.title || 'All FAQ'
        },
        {
            url: '/faq-category',
            message: labelDisplay?.[147]?.title || 'FAQ Category'
        }
    ]

    const advertiserMenuUrls = [
        {
            url: '/advertisers',
            message: labelDisplay?.[132]?.title || 'Advertisers',
            image: Manage_Advertiser_01,
        },
        {
            url: '/ads_categories',
            message: labelDisplay?.[133]?.title || 'Ads Categories',
            image: Ads_Categories_01,
        },
        {
            url: '/ads-list',
            message: labelDisplay?.[134]?.title || 'Ads List',
            image: add_list_01,
        },
        {
            url: '/advertisement-subscription-plans',
            message: labelDisplay?.[135]?.title || "Ads Subscription Plans",
            image: Ads_Plans_01,
        },
        {
            url: '/ads-monetization',
            message: labelDisplay?.[93]?.title || "Monetization Management",
            image: Ads_Plans_01,
        }
    ];

    const pushNotificationURL = [
        {
            url: "/push-notification-lists",
            message: "Push Notification List"
        },
        {
            url: "/add-push-notification",
            message: "Add Push Notification"
        }
    ]

    const donationURL = [
        {
            url: "/donation-details",
            message: "Donation Details"
        },
        {
            url: "/donation-transactions",
            message: "Donation Transactions"
        }
    ]

    return { superAdminURL, LibraryURL, artistURL, audioURL, faqURL, liveURL, userURL, menuURL, menuURLRegistrationMenu, videoURL, seriesURL, languageURL, regionURL, pagesURL, plansURL, paymentURL, analyticsURL, playerUrl, settingsURL, settingsURLhome, settingsURLApp, PartnerURL, Partner_payoutURL, RolesURL, PartnerPayout, deviceCropsURL, radioStationURL, importExportURL, donationURL, translationURL, partnerSettingsURL, imageOrientationURL, advertiserMenuUrls, pushNotificationURL, PartnerAnalyticsURL };
};

export default NavigationData;



// const audioURL = [
//     {
//         url: '/audio-lists',
//         message: 'All Audios'
//     },
//     {
//         url: '/add-audio',
//         message: 'Add New Audio'
//     },
//     {
//         url: '/audio-categories',
//         message: 'Manage Audio Categories'
//     },
//     {
//         url: '/manage-albums',
//         message: 'Manage Albums'
//     },
//     {
//         url: '/audio-approval',
//         message: 'Move Audio to Partner'
//     },
//     {
//         url: '/audio-content-partner',
//         message: 'Audio To Content Partner'
//     },
//     {
//         url: '/audio-channel-partner',
//         message: 'Audio To Channel Partner'
//     }
// ]

// const artistURL = [
//     {
//         url: '/all-artist',
//         message: 'All Artists'
//     },
//     {
//         url: '/add-artist',
//         message: 'Add New Artist'
//     },
//     {
//         url: '/artists-musician',
//         message: 'Record holder Artist'
//     },
//     // {
//     //     url: '/artists-songwriter',
//     //     message: 'Publisher/Songwriter'
//     // }
// ]

// const liveURL = [
//     {
//         url: '/livestream',
//         message: 'All Live Streams'
//     },
//     {
//         url: '/add-livestream',
//         message: 'Add New Live Stream'
//     },
//     {
//         url: '/CPPLiveVideosIndex',
//         message: 'Move Live Stream To Partner'
//     },
//     {
//         url: '/livestream-categories',
//         message: 'Manage Live Stream Categories'
//     },
//     {
//         url: '/live-content-partner',
//         message: 'Live Stream To Content Partner'
//     },
//     {
//         url: '/live-channel-partner',
//         message: 'Live Stream To Channel Partner'
//     },
//     // {
//     //     url: '/live-event-artist',
//     //     message: 'Live Event Artist'
//     // },
// ]

// const userURL = [
//     {
//         url: '/users',
//         message: 'All User'
//     },
//     {
//         url: '/add-users',
//         message: 'Add New User'
//     },
//     {
//         url: '/import-users-view',
//         message: 'Import User'
//     },
//     {
//         url: '/MultiUser-limit',
//         message: 'Multi User Management'
//     }]

// const menuURL = [
//     {
//         url: '/menu',
//         message: 'Menus'
//     },
//     {
//         url: '/footermenu',
//         message: 'Footer Menus'
//     },
//     {
//         url: '/mobilemenu',
//         message: 'Mobile Side Menus'
//     },
//     {
//         url: '/signup-menu',
//         message: 'Signup Menus'
//     },
//     // {
//     //     url: '/filemanager',
//     //     message: 'File Manager'
//     // }
// ]

// const videoURL = [
//     {
//         url: '/video-lists',
//         message: 'All Video'
//     },
//     {
//         url: '/add-video',
//         message: 'Add Video'
//     },
//     {
//         url: '/video-schedule',
//         message: 'Video Schedule'
//     },
//     {
//         url: '/video-partner',
//         message: 'Move Video To Partner'
//     },
//     {
//         url: '/video-categories',
//         message: 'Manage Video Categories'
//     },
//     {
//         url: '/allplaylist',
//         message: 'Manage Video Playlist'
//     },
//     {
//         url: '/video-content-partner',
//         message: 'Video To Content Partner'
//     },
//     {
//         url: '/video-channel-partner',
//         message: 'Video To Channel Partner'
//     },
//     // {
//     //     url: '/video-for-approval',
//     //     message: 'Video For Approval'
//     // },
// ]

// const seriesURL = [
//     {
//         url: '/series-list',
//         message: 'All Series'
//     },
//     {
//         url: '/add-series',
//         message: 'Add New Series'
//     },
//     {
//         url: '/series-category',
//         message: 'Manage Series Genre'
//     },
//     {
//         url: '/CPPSeriesIndex',
//         message: 'Move Series To Partner'
//     },
//     {
//         url: '/series-content-partner',
//         message: 'Series To Content Partner'
//     },
//     {
//         url: '/series-channel-partner',
//         message: 'Series To Channel Partner'
//     },
//     // {
//     //     url: '/all-episode',
//     //     message: 'All Episode'
//     // },
//     // {
//     //     url: '/manage-episode',
//     //     message: 'Manage Episode'
//     // },
//     // {
//     //     url: '/all-season',
//     //     message: 'All Season'
//     // },
//     // {
//     //     url: '/Add-season',
//     //     message: 'Add Season'
//     // },
//     // {
//     //     url: '/edit-season',
//     //     message: 'Edit Season'
//     // },

// ]
// const languageURL = [
//     {
//         url: '/admin-languages',
//         message: 'Equipment'
//     },
//     {
//         url: '/subtitlelanguage',
//         message: 'Subtitle Languages'
//     },
//     {
//         url: '/translate-languages',
//         message: 'Manage Translate Languages'
//     },
//     {
//         url: '/translate-languages-index',
//         message: 'Manage Translations'
//     }
// ]

// const contentPartnerURL = [
//     {
//         url: '/moderator',
//         message: 'Add Content Partner'
//     },
//     {
//         url: '/allmoderator',
//         message: 'View Content Partner'
//     },
//     {
//         url: '/allmoderator-approval',
//         message: 'Content Partner For Approval'
//     },
//     {
//         url: '/moderator/role',
//         message: 'Add Role'
//     },
//     {
//         url: '/moderator/view',
//         message: 'View Role'
//     },
//     {
//         url: '/moderator/commission',
//         message: 'Commission'
//     },
//     {
//         url: '/moderator/payouts',
//         message: 'Content Partners Payout'
//     },
// ]
// const channelPartnerURL = [
//     {
//         url: '/channel/user/create',
//         message: 'Add Channel Partner'
//     },
//     {
//         url: '/channel/view-channel-members',
//         message: 'View Channel Partner'
//     },
//     {
//         url: '/channel/partnerapproval',
//         message: 'Channel Partner For Approval'
//     },
//     {
//         url: '/channel/commission',
//         message: 'Commission'
//     },
//     {
//         url: '/channel/payouts',
//         message: 'Channel Partners Payout'
//     },
//     {
//         url: '/channel-package-index',
//         message: 'Channel Package'
//     }
// ]
// const pagesURL = [
//     {
//         url: '/pages',
//         message: 'All Pages'
//     },
//     {
//         url: '/landing-page/index',
//         message: 'Landing Pages'
//     },
//     // {
//     //     url: '/landing-page/create',
//     //     message: 'Create Landing Pages'
//     // },
// ]
// const plansURL = [
//     {
//         url: '/subscription-plans',
//         message: 'Manage Subscription Plans'
//     },
//     {
//         url: '/inapp-purchase',
//         message: 'Manage In App Purchase Plans'
//     },
//     {
//         url: '/life-time-subscription',
//         message: 'Life Time Subscription'
//     },
//     {
//         url: '/devices',
//         message: 'Devices'
//     },
// ]
// const paymentURL = [
//     {
//         url: '/payment/total_revenue',
//         message: 'Total Revenues'
//     },
//     {
//         url: '/payment/subscription',
//         message: 'Subscription Payments'
//     },
//     {
//         url: '/payment/payPerView',
//         message: 'PayPerView Payments'
//     }
// ]
// const analyticsURL = [
//     {
//         url: '/analytics/users',
//         message: 'Users Analytics'
//     },
//     {
//         url: '/analytics/subscriber',
//         message: 'Subscriber Analytics'
//     },
//     {
//         url: '/analytics/ppv',
//         message: 'PPV Analytics'
//     },
//     {
//         url: '/users/revenue',
//         message: 'Users Revenue'
//     },
//     {
//         url: '/video/purchased-analytics',
//         message: 'Purchased Video Analytics'
//     },
//     {
//         url: '/cpp/analytics',
//         message: 'CPP Analytics'
//     },
//     {
//         url: '/cpp/video-analytics',
//         message: 'CPP Video Analytics'
//     },
//     {
//         url: '/cpp/revenue',
//         message: 'CPP Revenue'
//     },
//     {
//         url: '/analytics/ViewsRegion',
//         message: 'View By Region'
//     },
//     {
//         url: '/analytics/RevenueRegion',
//         message: 'Revenue By Region'
//     },
//     {
//         url: '/analytics/PlayerVideoAnalytics',
//         message: 'Player Video Analytics'
//     },
//     {
//         url: '/analytics/RegionVideoAnalytics',
//         message: 'Region Video Analytics'
//     },
//     {
//         url: '/analytics/PlayerUserAnalytics',
//         message: 'Player User Analytics'
//     },
//     {
//         url: '/analytics/livestream-analytics',
//         message: 'CPP Live Video'
//     },
//     {
//         url: '/live/purchased-analytics',
//         message: 'Purchased LiveStream Analytics'
//     }
// ]

// const settingsURL = [
//     {
//         url: '/settings',
//         message: 'Storefront Settings'
//     },
//     {
//         url: '/home-settings',
//         message: 'HomePage Settings'
//     },
//     {
//         url: '/audio-settings',
//         message: 'AudioPage Settings'
//     },
//     {
//         url: '/movie-settings',
//         message: 'Movie Settings'
//     },
//     {
//         url: '/show-settings',
//         message: 'Show Settings'
//     },
//     {
//         url: '/linking_settings',
//         message: 'Link Settings'
//     },
//     {
//         url: '/age/index',
//         message: 'Manage Age'
//     },
//     {
//         url: '/theme_settings',
//         message: 'Theme Settings'
//     },
//     {
//         url: '/email_settings',
//         message: 'Email Settings'
//     },
//     {
//         url: '/payment_settings',
//         message: 'Payment Settings'
//     },
//     {
//         url: '/storage_settings',
//         message: 'Storage Settings'
//     },
//     {
//         url: '/mobileapp',
//         message: 'Mobile App Settings'
//     },
//     {
//         url: '/system_settings',
//         message: 'Social Login Settings'
//     },
//     {
//         url: '/currency_settings',
//         message: 'Currency Settings'
//     },
//     {
//         url: '/revenue_settings/index',
//         message: 'Revenue Settings'
//     },
//     {
//         url: '/ThumbnailSetting',
//         message: 'Thumbnail Settings'
//     },
//     {
//         url: '/ChooseProfileScreen',
//         message: 'Profile Screen'
//     },
//     {
//         url: '/compress-image-setting',
//         message: 'Image Settings'
//     },
//     {
//         url: '/pop-up-setting',
//         message: 'Home Page Pop Up Settings'
//     },
//     {
//         url: '/comment-section-setting',
//         message: 'Comment Settings'
//     },
//     {
//         url: '/site-meta-settings',
//         message: 'Site Meta Settings'
//     },
//     {
//         url: '/tv-settings',
//         message: 'Tv Settings'
//     },
//     {
//         url: '/dsp-settings',
//         message: 'DSP Settings'
//     },
//     {
//         url: '/labels',
//         message: 'Labels Settings'
//     },
//     // {
//     //     url: '/ThemeIntegration',
//     //     message: 'Theme'
//     // },
// ]

// const advertiserURL = [
//     {
//         url: '/advertisers',
//         message: 'Advertiser'
//     }
// ]
// const faqURL = [
//     {
//         url: '/faq',
//         message: 'FAQ'
//     },
//     {
//         url: '/faq-category',
//         message: 'FAQ Category'
//     }
// ]

// export { artistURL, audioURL, faqURL, liveURL, userURL, menuURL, videoURL, seriesURL, languageURL, contentPartnerURL, channelPartnerURL, pagesURL, plansURL, paymentURL, analyticsURL, settingsURL, advertiserURL }